<div class="svinn-container">
  <form (ngSubmit)="onSubmit()" class="svinn-form">
    <div class="food-items-list">
      <mat-card *ngFor="let item of filteredFoodItems; let i = index" class="food-item-card" [class.modified]="item.input !== item.oldValue">
        <mat-card-content>
          <div class="item-details">
            <span class="item-name">{{ item.name }}</span>
            <div class="quantity-controls">
              <button type="button" mat-icon-button (click)="decrement(item)" [disabled]="item.input <= 0" color="warn">
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
              
              <input type="number" 
                     [id]="'input' + i" 
                     [name]="'input' + i" 
                     min="0" max="99" 
                     class="quantity-input"
                     (input)="inputChanged(item, i)" 
                     [(ngModel)]="item.input" 
                     (click)="onFieldClick($event)" 
                     onlyNumber="true"/>

              <button type="button" mat-icon-button (click)="increment(item)" color="primary">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
            </div>
            
            <div class="status-indicator">
              <mat-icon *ngIf="item.input > 0 && item.input === item.oldValue" class="synced-icon">check_circle</mat-icon>
              <mat-icon *ngIf="item.input !== item.oldValue" class="modified-icon" matTooltip="Unsaved changes">pending</mat-icon>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="form-footer">
      <button mat-raised-button color="primary" class="submit-button" type="submit" [disabled]="isSaving">
        <mat-icon *ngIf="!isSaving">cloud_upload</mat-icon>
        <mat-spinner *ngIf="isSaving" [diameter]="20" style="margin-right: 8px;"></mat-spinner>
        {{ isSaving ? 'Saving...' : 'Register Svinn' }}
      </button>
    </div>
  </form>
</div>
